/*
 * $Id:: CannotDeactivateDialog.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';

import { t } from '../../../../providers';

const useStyles = makeStyles((theme) => ({
    dialogOverride: {
        padding: '20px',
        color: 'black',
    },
    okButton: {
        backgroundColor: theme.palette.text.mainGreen,
        minWidth: '66px',
        textTransform: 'uppercase',
        '&:focus-visible': {
            outline: 'none',
            border: '2px dashed #4F7E1D !important',
            borderRadius: '3px',
        },
        '&:hover': {
            backgroundColor: theme.palette.text.mainGreen,
        },
        '&:active': {
            backgroundColor: theme.palette.text.mainGreen,
        },
    },
}));

const CannotDeactivateDialog = ({ open, onAccept }) => {
    const classes = useStyles();
    return (
        <Dialog open={open} onClose={onAccept} aria-labelledby="confirm-status-update-dialog" className={classes.dialogOverride}>
            <DialogTitle id="form-dialog-title">{t('important.notice')}</DialogTitle>
            <DialogContent>
                <DialogContentText>{t('deactivate.account.info')}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button disableFocusRipple className={classes.okButton} variant="contained" onClick={onAccept}>
                    {t('ok')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CannotDeactivateDialog;
